import { ErrorMessages, Errors } from "./ErrorMessages";

export const extractErrorMessage = (errorResponse: any): string => {
  let errorMessage: string = "";
  
  if(errorResponse?.code === Errors.NETWORK_ERROR){
    errorMessage = ErrorMessages.NETWORK_ERROR;
  }
  else {
    const apiErrorResponse: string = errorResponse?.response?.data?.message || "";
    if (apiErrorResponse) {
      try {
        const parsedError = JSON.parse(apiErrorResponse);
        errorMessage = parsedError?.description || apiErrorResponse;
      } catch (error) {
        errorMessage = apiErrorResponse;
      }
    }
  }
  return errorMessage;
};